import React from "react";
import { Box, Grid, Typography, Checkbox, FormControlLabel } from "@mui/material";
import TextInputComponent from "../../ui/TextInputComponent";
import SelectInputComponent from "../../ui/SelectInputComponent";
import ButtonComponent from "../../ui/ButtonComponent";

const AdvancedStep = ({ 
    formData = {}, 
    handleChange, 
    errors, 
    setFormData,
    spreadsheetError,
    handleBudgetFileUpload,
    handleGenerateDescription,
    loadingDescription,
    }) => {

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextInputComponent
          label="Event Description"
          value={formData.description}
          onChange={handleChange("description")}
          multiline
          placeholder="Describe your event or generate one using Kinova AI..."
        />
      </Grid>

      <Grid item xs={12} display="flex" justifyContent="flex-end">
        <ButtonComponent
            label={loadingDescription ? "Generating..." : "Let Kinova Write It"}
            type="secondary"
            disabled={loadingDescription}
            onClick={handleGenerateDescription}
            />
                  
      </Grid>

      <Grid item xs={12} md={6}>
        <SelectInputComponent
          label="Allow RSVPs"
          value={formData.allowRsvps}
          onChange={handleChange("allowRsvps")}
          options={[
            { label: "Yes", value: true },
            { label: "No", value: false },
          ]}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <SelectInputComponent
          label="Visible to Public"
          value={formData.visibleToPublic}
          onChange={handleChange("visibleToPublic")}
          options={[
            { label: "Yes", value: true },
            { label: "No", value: false },
          ]}
        />
      </Grid>

      <Grid item xs={12}>
        <TextInputComponent
          label="Event Tags (comma-separated)"
          value={formData.tags}
          onChange={handleChange("tags")}
        />
      </Grid>

      <Grid item xs={12}>
        <TextInputComponent
          label="Internal Notes"
          value={formData.internalNotes}
          onChange={handleChange("internalNotes")}
          multiline
          rows={4}
        />
      </Grid>

        <Box mt={3}>
        <Grid container spacing={2}>
            {/* Budget Upload */}
            <Grid item xs={12} mt={6} mb={6}>
            <Typography variant="h6" gutterBottom sx={{ mb: 1 }}>
                Upload Budget Spreadsheet
            </Typography>

            <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                Accepted file types: .csv or .xlsx
            </Typography>

            <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
                <input
                type="file"
                id="budgetUploadInput"
                accept=".csv,.xlsx"
                onChange={handleBudgetFileUpload}
                style={{ display: "none" }}
                />
                <label htmlFor="budgetUploadInput">
                <ButtonComponent
                    label="Choose File"
                    type="secondary"
                    onClick={() => document.getElementById("budgetUploadInput").click()}
                />
                </label>

                {formData.budget && (
                <>
                    <Typography variant="body2">
                    Selected File: <strong>{formData.budget}</strong>
                    </Typography>
                    <ButtonComponent
                    label="Remove"
                    type="danger"
                    onClick={() =>
                        setFormData((prev) => ({
                        ...prev,
                        budget: "",
                        estimatedCost: 0,
                        }))
                    }
                    />
                </>
                )}
            </Box>

            {spreadsheetError && (
                <Typography color="error" sx={{ mt: 1 }}>
                {spreadsheetError}
                </Typography>
            )}

            {formData.estimatedCost > 0 && (
                <Typography variant="body2" sx={{ mt: 2 }}>
                Estimated Event Cost: ${formData.estimatedCost}
                </Typography>
            )}
            </Grid>
        </Grid>
        </Box>
    </Grid>
  );
};

export default AdvancedStep;
